import { render } from "./FontManager.vue?vue&type=template&id=60eceef0&scoped=true"
import script from "./FontManager.vue?vue&type=script&lang=js"
export * from "./FontManager.vue?vue&type=script&lang=js"

import "./FontManager.vue?vue&type=style&index=0&id=60eceef0&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eceef0"]])

export default __exports__